export { default as Img200 } from './processed/200/FLIGHTPLAN.jpg';
export { default as Img400 } from './processed/400/FLIGHTPLAN.jpg';
export { default as Imgthumb } from './processed/thumb/FLIGHTPLAN.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/FLIGHTPLAN.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/FLIGHTPLAN.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      51,
      190,
      230
    ],
    "_population": 74,
    "_hsl": [
      0.537243947858473,
      0.781659388646288,
      0.5509803921568628
    ]
  },
  "LightVibrant": {
    "_rgb": [
      242,
      190,
      146
    ],
    "_population": 3296,
    "_hsl": [
      0.07638888888888891,
      0.7868852459016392,
      0.7607843137254902
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      76,
      132
    ],
    "_population": 12,
    "_hsl": [
      0.5729166666666666,
      0.9411764705882351,
      0.2666666666666667
    ]
  },
  "Muted": {
    "_rgb": [
      165,
      112,
      89
    ],
    "_population": 796,
    "_hsl": [
      0.05043859649122807,
      0.2992125984251969,
      0.4980392156862745
    ]
  },
  "LightMuted": {
    "_rgb": [
      164,
      205,
      168
    ],
    "_population": 5,
    "_hsl": [
      0.3495934959349593,
      0.29078014184397166,
      0.723529411764706
    ]
  },
  "DarkMuted": {
    "_rgb": [
      92,
      64,
      58
    ],
    "_population": 962,
    "_hsl": [
      0.029411764705882356,
      0.22666666666666666,
      0.29411764705882354
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/FLIGHTPLAN.js